import { useState, useEffect, useRef } from 'react';

export default function CTA() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const benefits = [
    {
      icon: 'ri-focus-3-line',
      title: 'Quản lý tập trung',
      description: 'Minh bạch – xuyên suốt'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Trải nghiệm khách hàng',
      description: 'Nâng cao sự hài lòng'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Hiệu quả vận hành',
      description: 'Tăng doanh thu bền vững'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Sẵn sàng mở rộng',
      description: 'Chuyển đổi số dài hạn'
    }
  ];

  return (
    <section ref={sectionRef} id="contact" className="py-12 sm:py-16 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20business%20team%20collaboration%20workspace%20with%20digital%20technology%20elements%2C%20abstract%20geometric%20patterns%20and%20flowing%20data%20visualization%20in%20cyan%20and%20teal%20gradient%20colors%2C%20professional%20corporate%20environment%20with%20soft%20lighting%20and%20depth%20of%20field%2C%20inspiring%20and%20motivational%20atmosphere&width=1920&height=800&seq=cta-bg-001&orientation=landscape"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2a4b7c]/95 to-[#3d5a80]/95"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className={`text-center mb-8 sm:mb-12 md:mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Stackway CRM – Không chỉ là CRM,<br className="hidden sm:block" />mà là nền tảng vận hành doanh nghiệp
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-8 sm:mb-12 px-4">
            Giải pháp toàn diện giúp doanh nghiệp B2B & B2C chuyển đổi số thành công
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 md:mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className={`bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20 hover:bg-white/20 transition-all text-center ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
            }`} style={{ transitionDelay: `${200 + index * 100}ms` }}>
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-lg bg-gradient-to-br from-[#06b6d4] to-[#00c897] mx-auto mb-3 sm:mb-4">
                <i className={`${benefit.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h4 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">{benefit.title}</h4>
              <p className="text-xs sm:text-sm text-white/80">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className={`text-center transition-all duration-1000 delay-600 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-6 sm:mb-8">
            <button className="px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 bg-gradient-to-r from-[#06b6d4] to-[#00c897] text-white rounded-lg font-bold text-sm sm:text-base md:text-lg hover:shadow-2xl transition-all inline-flex items-center justify-center space-x-2 sm:space-x-3 cursor-pointer">
              <i className="ri-rocket-line text-lg sm:text-xl"></i>
              <span>Bắt đầu dùng thử miễn phí</span>
            </button>
            <button className="px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 bg-white text-[#2a4b7c] rounded-lg font-bold text-sm sm:text-base md:text-lg hover:shadow-2xl transition-all inline-flex items-center justify-center space-x-2 sm:space-x-3 cursor-pointer">
              <i className="ri-customer-service-line text-lg sm:text-xl"></i>
              <span>Đặt lịch tư vấn</span>
            </button>
          </div>
        </div>
      
      </div>
    </section>
  );
}
